<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgement">
<h1>Acknowledgement</h1>
<p style="text-align: center;">I would like to thank a film maker, Claudio Colomba from Castellammare del Golfo, Sicily. The story line was originally a movie script to be filmed in NYC and Sicily with Claudio Colomba’s productions.</p><br/>
<p style="text-align: center;">He provided all the necessary travel and accommodations in Sicily to accomplish the project that led to the book form.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch004.vue?1506f198